import { AfterViewInit, Component, ElementRef, inject, OnDestroy, ViewChild } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { Subscription } from 'rxjs';
import { ModalService } from '../../services/modal.service';
import { ModalConfig } from '../../models/modal-config';
import { ModalAction } from '../../models/modal-action';

@Component({
  selector: 'app-modal',
  imports: [TegelModule],
  templateUrl: './modal.html',
  styles: `
    .modal-focus-origin {
      position: fixed;
      width: 1px;
      height: 1px;
      padding: 0;
      border: 0;
      opacity: 0;
      pointer-events: none;
    }
  `,
})
export class Modal implements AfterViewInit, OnDestroy {
  private readonly modalService = inject(ModalService);
  @ViewChild('modalEl', { read: ElementRef }) modalEl!: ElementRef<HTMLElement>;

  config: ModalConfig = {};
  actions: ModalAction[] = [];
  private sub?: Subscription;
  private resolver?: (v: any) => void;

  ngAfterViewInit(): void {
    this.sub = this.modalService.requests$.subscribe(async (req) => {
      this.config = req.config;
      this.actions = [...(req.config.actions ?? [])];
      this.resolver = req.resolve;

      const el = this.modalEl?.nativeElement as any;

      if (!el) {
        console.error('[ModalHost] modalEl is undefined (ViewChild not resolved)');
        req.resolve({ ok: false, error: 'modalEl undefined' });
        return;
      }

      el.header = this.config.header ?? '';
      el.size = this.config.size ?? 'md';
      el.prevent = !!this.config.preventBackdropClose;
      el.closable = this.config.closable ?? true;
      el.referenceEl = req.focusOrigin;

      if (typeof el.showModal === 'function') {
        await el.showModal();
      } else {
        console.error('[ModalHost] showModal() not available (Tegel not registered?)');
      }
    });
  }

  async onActionClick(a: ModalAction) {
    await a.onClick?.();

    if (a.dismiss) {
      await this.close(a);
    }
  }

  async close(result?: any) {
    const el = this.modalEl.nativeElement as any;
    await el.closeModal();
    this.resolver?.(result);
    this.resolver = undefined;
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
